import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-rc-table',
  templateUrl: './rc-table.component.html',
  standalone: true,
})
export class RcTableComponent {
  @Input() tableHeaders: string[];
}
